import React from 'react'
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Stack
} from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

interface PaginationControlsProps {
  currentPage: number
  pageSize: number
  totalCount: number
  pageSizeOptions: number[]
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  pageSize,
  totalCount,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize)
  const startIndex = (currentPage - 1) * pageSize + 1
  const endIndex = Math.min(currentPage * pageSize, totalCount)

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          Rows per page:
        </Typography>
        <FormControl size="small" sx={{ minWidth: 70 }}>
          <Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            variant="standard"
            sx={{ fontSize: '0.875rem' }}
          >
            {pageSizeOptions.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: '0.875rem' }}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
        {totalCount > 0 ? `${startIndex}–${endIndex} of ${totalCount}` : '0 of 0'}
      </Typography>

      <Stack direction="row" spacing={0}>
        <IconButton
          onClick={handlePreviousPage}
          disabled={currentPage <= 1}
          size="small"
          sx={{ fontSize: '0.875rem' }}
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleNextPage}
          disabled={currentPage >= totalPages}
          size="small"
          sx={{ fontSize: '0.875rem' }}
        >
          <ChevronRight fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  )
}
